// extracted by mini-css-extract-plugin
export default {"home":"HomePage_home__9+SqM","container":"HomePage_container__ey36L","link":"HomePage_link__TcEDa"};